// notif — pencatatan notifikasi ke tabel notifications (best-effort, tak memblok aksi utama).
// UI lonceng menyusul sebagai modul Notifikasi tersendiri. Target: 'CS'|'SPV'|'FINANCE'|'TEK:<nama>'|'EMP:<id>'.
import { supabase } from './supabase';

export async function pushNotif(target: string, outlet: string | null, text: string, ticketNo?: string, tahap?: string | null): Promise<void> {
  try {
    const { error } = await supabase().from('notifications')
      .insert({ target, outlet, text, ticket_no: ticketNo ?? null, tahap: tahap ?? null });
    if (error) console.warn('[notif] gagal simpan:', error.message);
  } catch (e) { console.warn('[notif] error:', e); }
}

/**
 * HAPUS notif TUGAS sebuah tiket untuk `target` tertentu — dipanggil saat tugasnya SELESAI
 * lewat aksi yang TIDAK memajukan status tiket (mis. Finance verifikasi pembayaran → notif
 * "perlu verifikasi" harus LENYAP dari lonceng, bukan sekadar ditandai-baca — sebab panel tetap
 * menampilkan yang sudah-dibaca sehingga menumpuk). Dihapus, bukan mark-read: pemicunya tugas
 * SELESAI (bukan sekadar dilihat), jadi aman — tugas yang belum selesai tak ikut hilang.
 * Untuk tugas yang memajukan status, penyelesaian sudah ditangani `tahap` di aktif().
 * Rekam jejak tetap ada di log tiket + notif konfirmasi (mis. "TERVERIFIKASI" ke CS).
 * Best-effort — tak memblok aksi utama.
 */
export async function resolveTaskNotif(ticketNo: string, target: string): Promise<void> {
  try {
    const { error } = await supabase().from('notifications')
      .delete().eq('ticket_no', ticketNo).eq('target', target);
    if (error) console.warn('[notif] resolve gagal:', error.message);
  } catch (e) { console.warn('[notif] resolve error:', e); }
}
